import React from "react";
import "./contactMap.css";

const ContactMap = () => {
  return (
    <section className="map-section">
      <iframe
        title="INTEL BUILD Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.287894761594!2d72.83214687525461!3d19.13887124999571!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b6277c974603%3A0x198d5b4c3ee0e30a!2sINTELBUILD!5e0!3m2!1sen!2sin!4v1765969030289!5m2!1sen!2sin"
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    </section>
  );
};

export default ContactMap;
